import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const COUNTRY_CODES = [
  { code: "+1", country: "US", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "+1", country: "CA", flag: "\u{1F1E8}\u{1F1E6}" },
  { code: "+44", country: "GB", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "+91", country: "IN", flag: "\u{1F1EE}\u{1F1F3}" },
  { code: "+61", country: "AU", flag: "\u{1F1E6}\u{1F1FA}" },
  { code: "+49", country: "DE", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "+33", country: "FR", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "+86", country: "CN", flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "+81", country: "JP", flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "+82", country: "KR", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "+55", country: "BR", flag: "\u{1F1E7}\u{1F1F7}" },
  { code: "+52", country: "MX", flag: "\u{1F1F2}\u{1F1FD}" },
  { code: "+234", country: "NG", flag: "\u{1F1F3}\u{1F1EC}" },
  { code: "+27", country: "ZA", flag: "\u{1F1FF}\u{1F1E6}" },
  { code: "+971", country: "AE", flag: "\u{1F1E6}\u{1F1EA}" },
  { code: "+966", country: "SA", flag: "\u{1F1F8}\u{1F1E6}" },
  { code: "+63", country: "PH", flag: "\u{1F1F5}\u{1F1ED}" },
];

const formatPhoneNumber = (value) => {
  if (!value) return "";
  const phoneNumber = value.replace(/\D/g, "");
  const len = phoneNumber.length;
  if (len < 4) return phoneNumber;
  if (len < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const PhoneInputWithCode = ({
  value = "",
  countryCode = "+1",
  onPhoneChange,
  onCodeChange,
  placeholder = "(000) 000-0000",
  className = "",
  inputClassName = "",
  testId = "phone-input",
  theme = "dark",
}) => {
  const isDark = theme === "dark";

  return (
    <div className={`flex gap-2 ${className}`}>
      <Select value={countryCode} onValueChange={onCodeChange}>
        <SelectTrigger
          className={`w-[90px] h-12 rounded-full px-3 shrink-0 ${
            isDark
              ? "bg-black/30 border-white/[0.08] text-white focus:border-[#A1D8E0] focus:ring-2 focus:ring-[#A1D8E0]/20"
              : "bg-white border-gray-300 text-gray-900 focus:border-[#00677F] focus:ring-2 focus:ring-[#00677F]/20"
          }`}
          data-testid={`${testId}-code`}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className={`rounded-xl ${isDark ? "bg-[#11161F] border-white/10" : "bg-white border-gray-200"}`}>
          {COUNTRY_CODES.map((c) => (
            <SelectItem key={`${c.country}-${c.code}`} value={`${c.code}|${c.country}`}>
              <span className="flex items-center gap-1.5">
                <span>{c.flag}</span>
                <span className="text-xs">{c.code}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        type="tel"
        inputMode="numeric"
        value={formatPhoneNumber(value)}
        onChange={(e) => onPhoneChange(formatPhoneNumber(e.target.value))}
        placeholder={placeholder}
        className={`h-12 flex-1 rounded-full px-5 transition-all duration-300 ${
          isDark
            ? "bg-black/30 border-white/[0.08] focus:border-[#A1D8E0] focus:ring-2 focus:ring-[#A1D8E0]/20 text-white placeholder:text-slate-600"
            : "bg-white border-gray-300 focus:border-[#00677F] focus:ring-2 focus:ring-[#00677F]/20 text-gray-900 placeholder:text-gray-400"
        } ${inputClassName}`}
        data-testid={testId}
      />
    </div>
  );
};

export { PhoneInputWithCode, formatPhoneNumber, COUNTRY_CODES };
export default PhoneInputWithCode;
